import React, { useEffect, useRef, useState } from "react";
import { useDocumentTitle } from "../../../../hooks/customDocumentTitleHook";
import { useLocation } from "react-router-dom";
import { getPractice, getSecureData } from "../../../../helpers";

export default function PatientSurveyPrintStatus() {

  const [formData, setFormData] = useState(null);
  const [printFilter, setPrintFilter] = useState(null);
  const [ImgStatusCode, setImgStatusCode] = useState(null);
  const contentRef = useRef();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const formSize = queryParams.get('size');
  const imageUrl = `${getPractice("website")}/logo.png`;

  useEffect(() => {
    const LogoImg = new Image();
    LogoImg.onload = () => {
      setImgStatusCode(200);
    };
    LogoImg.onerror = () => {
      setImgStatusCode('Error');
    };
    LogoImg.src = imageUrl;
  }, [imageUrl]);

  useEffect(() => {
    const fetchStoredData = async () => {
      const storedData = await getSecureData("surveyPrintData");
      if (storedData) {
        setFormData(storedData.results);
        setPrintFilter(storedData.filter);
      }
    };
    
     fetchStoredData();
  }, []);

  const handlePrint = () => {
    window.print();
  };

  const handleCloseWindow = () => {
    window.close();
  };

  useEffect(() => {
    const pageSize = formSize == "A4" ? "A4" : "Letter";
    const styleElement = document.createElement("style");
    styleElement.innerHTML = `
      @media print {
        @page {
          size: ${pageSize};
        }
      }
    `;
    document.head.appendChild(styleElement);
    return () => {
      document.head.removeChild(styleElement);
    };
  }, [formSize]);
  

  useDocumentTitle("Patient Survey Form");

  return (
    <div ref={contentRef} className="docpro_signout_wrap">
      <div className="docpro_signout">
        <div className="patient_survey_status">
          <div className="docpro_signout_header mb-0" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70px', borderBottom: 0 }}>
            <div className="docpro_signout_logo">
              {ImgStatusCode === null ? (
                <img 
                  src="/images/logo.svg" 
                  alt="Logo" 
                  style={{ height: "36px" }}
                />
              ) : ImgStatusCode === 200 ? (
                <img 
                  src={imageUrl} 
                  alt="Logo" 
                  style={{ height: "36px" }}
                />
              ) : (
                <img 
                  src="/images/logo.svg" 
                  alt="Logo" 
                  style={{ height: "36px" }}
                />
              )}
            </div>
          </div>

          <h4 className="text-center mb-1">Patient Feedback Survey</h4>
          <p className="text-center pb-2">
            <b>Duration: </b> 
            {printFilter?.from_dos}
            {printFilter?.to_dos && printFilter?.from_dos !== printFilter?.to_dos && ` - ${printFilter.to_dos}`}
          </p>
          <p className="text-start pb-2">
            <b>Numerator : </b> 
            {formData?.total}{' '}
            (Total number of patients who completed survey)
          </p>

          <div className="docpro_table_1 hipaa_table mt-4" style={{ boxShadow: 'none', borderRadius: 0 }}>
            <table className="docpro_mb_0 docpro_primary_color" style={{ width: '100%' }}>
              <thead>
                <th colspan="5" className="text-center" style={{ background: '#8090c59e', fontSize: 'medium' }}>Access</th>
              </thead>
              <thead>
                <tr>
                  <th style={{ width:'50px', borderRight: '1px solid var(--border)' }} className="text-center">Sr.</th>
                  <th style={{ width: '50%', borderRight: '1px solid var(--border)' }} className="text-center">Question</th>
                  <th className="text-center fw-bold" style={{ borderRight: '1px solid var(--border)' }}>%</th>
                  <th className="text-center fw-bold" style={{ borderRight: '1px solid var(--border)' }}>%</th>
                  <th className="text-center fw-bold">%</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}> 1 </td>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0">Are you/family/caregiver able to see your doctor when you need to?</p>
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    YES <br/> {formData?.total_survey_1_yes ?? 0}
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    SOMETIMES <br/> {formData?.total_survey_1_sometime ?? 0}
                  </td>
                  <td className="text-center">
                    NO <br/> {formData?.total_survey_1_no ?? 0}
                  </td>
                </tr>
                <tr>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}> 2 </td>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0">Can you/family/caregiver be seen on the same day that you call for an appointment?</p>
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    YES <br/> {formData?.total_survey_2_yes ?? 0}
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    SOMETIMES <br/> {formData?.total_survey_2_sometime ?? 0}
                  </td>
                  <td className="text-center">
                    NO <br/> {formData?.total_survey_2_no ?? 0}
                  </td>
                </tr>
                <tr>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}> 3 </td>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0">Do you/family/caregiver know that there is a phone number that you can call to receive medical advice from the doctor after regular business hours?</p>
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    YES <br/> {formData?.total_survey_3_yes ?? 0}
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    SOMETIMES <br/> {formData?.total_survey_3_sometime ?? 0}
                  </td>
                  <td className="text-center">
                    NO <br/> {formData?.total_survey_3_no ?? 0}
                  </td>
                </tr>
                <tr>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}> 4 </td>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0">When you/family/caregiver call your doctor with a medical question, do you get an answer on that same day?</p>
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    YES <br/> {formData?.total_survey_4_yes ?? 0}
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    SOMETIMES <br/> {formData?.total_survey_4_sometime ?? 0}
                  </td>
                  <td className="text-center">
                    NO <br/> {formData?.total_survey_4_no ?? 0}
                  </td>
                </tr>
                <tr>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}> 5 </td>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0">The practice space is clean and inviting?</p>
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    YES <br/> {formData?.total_survey_5_yes ?? 0}
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    SOMETIMES <br/> {formData?.total_survey_5_sometime ?? 0}
                  </td>
                  <td className="text-center">
                    NO <br/> {formData?.total_survey_5_no ?? 0}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="docpro_table_1 hipaa_table mt-4" style={{ boxShadow: 'none', borderRadius: 0 }}>
            <table className="docpro_mb_0 docpro_primary_color" style={{ width: '100%' }}>
              <thead>
                <th colspan="5" className="text-center" style={{ background: '#8090c59e', fontSize: 'medium' }}>Communication</th>
              </thead>
              <thead>
                <tr>
                  <th style={{ width:'50px', borderRight: '1px solid var(--border)' }} className="text-center">Sr.</th>
                  <th style={{ width: '50%', borderRight: '1px solid var(--border)' }} className="text-center">Question</th>
                  <th className="text-center fw-bold" style={{ borderRight: '1px solid var(--border)' }}>%</th>
                  <th className="text-center fw-bold" style={{ borderRight: '1px solid var(--border)' }}>%</th>
                  <th className="text-center fw-bold">%</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}> 6 </td>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0">Does your doctor explain things in a way that is easy to understand?</p>
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    YES <br/> {formData?.total_survey_6_yes ?? 0}
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    SOMETIMES <br/> {formData?.total_survey_6_sometime ?? 0}
                  </td>
                  <td className="text-center">
                    NO <br/> {formData?.total_survey_6_no ?? 0}
                  </td>
                </tr>
                <tr>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}> 7 </td>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0">Does your doctor talk with you about the medications you are taking at each visit?</p>
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    YES <br/> {formData?.total_survey_7_yes ?? 0}
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    SOMETIMES <br/> {formData?.total_survey_7_sometime ?? 0}
                  </td>
                  <td className="text-center">
                    NO <br/> {formData?.total_survey_7_no ?? 0}
                  </td>
                </tr>
                <tr>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}> 8 </td>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0">Are medical staff friendly and helpful?</p>
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    YES <br/> {formData?.total_survey_8_yes ?? 0}
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    SOMETIMES <br/> {formData?.total_survey_8_sometime ?? 0}
                  </td>
                  <td className="text-center">
                    NO <br/> {formData?.total_survey_8_no ?? 0}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="docpro_table_1 hipaa_table mt-4" style={{ boxShadow: 'none', borderRadius: 0 }}>
            <table className="docpro_mb_0 docpro_primary_color" style={{ width: '100%' }}>
              <thead>
                <th colspan="5" className="text-center" style={{ background: '#8090c59e', fontSize: 'medium' }}>Coordination</th>
              </thead>
              <thead>
                <tr>
                  <th style={{ width:'50px', borderRight: '1px solid var(--border)' }} className="text-center">Sr.</th>
                  <th style={{ width: '50%', borderRight: '1px solid var(--border)' }} className="text-center">Question</th>
                  <th className="text-center fw-bold" style={{ borderRight: '1px solid var(--border)' }}>%</th>
                  <th className="text-center fw-bold" style={{ borderRight: '1px solid var(--border)' }}>%</th>
                  <th className="text-center fw-bold">%</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}> 9 </td>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0">When blood tests, x-rays, or other tests are ordered, does the practice give you the results?</p>
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    YES <br/> {formData?.total_survey_9_yes ?? 0}
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    SOMETIMES <br/> {formData?.total_survey_9_sometime ?? 0}
                  </td>
                  <td className="text-center">
                    NO <br/> {formData?.total_survey_9_no ?? 0}
                  </td>
                </tr>
                <tr>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}> 10 </td>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0">If you/family/caregiver have received care from a specialist, does your doctor seem to know about the care you received?</p>
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    YES <br/> {formData?.total_survey_10_yes ?? 0}
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    SOMETIMES <br/> {formData?.total_survey_10_sometime ?? 0}
                  </td>
                  <td className="text-center">
                    NO <br/> {formData?.total_survey_10_no ?? 0}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {formSize == 'A4' ?
            <div className="spacing_6"></div>
          :
            <div className="spacing_7"></div>
          }

          <div className="docpro_table_1 hipaa_table mt-4" style={{ boxShadow: 'none', borderRadius: 0 }}>
            <table className="docpro_mb_0 docpro_primary_color" style={{ width: '100%' }}>
              <thead>
                <th colspan="5" className="text-center" style={{ background: '#8090c59e', fontSize: 'medium' }}>Self-Management Support</th>
              </thead>
              <thead>
                <tr>
                  <th style={{ width:'50px', borderRight: '1px solid var(--border)' }} className="text-center">Sr.</th>
                  <th style={{ width: '50%', borderRight: '1px solid var(--border)' }} className="text-center">Question</th>
                  <th className="text-center fw-bold" style={{ borderRight: '1px solid var(--border)' }}>%</th>
                  <th className="text-center fw-bold" style={{ borderRight: '1px solid var(--border)' }}>%</th>
                  <th className="text-center fw-bold">%</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}> 11 </td>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0">Does your doctor provide information on ways to improve your health?</p>
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    YES <br/> {formData?.total_survey_11_yes ?? 0}
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    SOMETIMES <br/> {formData?.total_survey_11_sometime ?? 0}
                  </td>
                  <td className="text-center">
                    NO <br/> {formData?.total_survey_11_no ?? 0}
                  </td>
                </tr>
                <tr>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}> 12 </td>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0">Has your doctor asked if there are things that make it hard for you to take care of your health?</p>
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    YES <br/> {formData?.total_survey_12_yes ?? 0}
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    SOMETIMES <br/> {formData?.total_survey_12_sometime ?? 0}
                  </td>
                  <td className="text-center">
                    NO <br/> {formData?.total_survey_12_no ?? 0}
                  </td>
                </tr>
                <tr>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}> 13 </td>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0">Have staff at the practice recommended services in your community or offered their own workshops to help improve your health (e.g., weight management groups, nutrition/meal support)?</p>
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    YES <br/> {formData?.total_survey_13_yes ?? 0}
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    SOMETIMES <br/> {formData?.total_survey_13_sometime ?? 0}
                  </td>
                  <td className="text-center">
                    NO <br/> {formData?.total_survey_13_no ?? 0}
                  </td>
                </tr>
                <tr>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}> 14 </td>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0">Are recommendations to you/family/caregiver received (including community service and supports) to improve your health helpful?</p>
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    YES <br/> {formData?.total_survey_14_yes ?? 0}
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    SOMETIMES <br/> {formData?.total_survey_14_sometime ?? 0}
                  </td>
                  <td className="text-center">
                    NO <br/> {formData?.total_survey_14_no ?? 0}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="docpro_table_1 hipaa_table mt-4" style={{ boxShadow: 'none', borderRadius: 0 }}>
            <table className="docpro_mb_0 docpro_primary_color" style={{ width: '100%' }}>
              <thead>
                <th colspan="7" className="text-center" style={{ background: '#8090c59e', fontSize: 'medium' }}>Access</th>
              </thead>
              <thead>
                <tr>
                  <th style={{ width:'50px', borderRight: '1px solid var(--border)' }} className="text-center">Sr.</th>
                  <th style={{ width: '50%', borderRight: '1px solid var(--border)' }} className="text-center">Question</th>
                  <th className="text-center fw-bold" style={{ borderRight: '1px solid var(--border)' }}>%</th>
                  <th className="text-center fw-bold" style={{ borderRight: '1px solid var(--border)' }}>%</th>
                  <th className="text-center fw-bold" style={{ borderRight: '1px solid var(--border)' }}>%</th>
                  <th className="text-center fw-bold" style={{ borderRight: '1px solid var(--border)' }}>%</th>
                  <th className="text-center fw-bold">%</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}> 15 </td>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0">What is your preferred method of communication?</p>
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    Phone <br/> {formData?.total_survey_15_phone ?? 0}
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    Text <br/> {formData?.total_survey_15_text ?? 0}
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    Email <br/> {formData?.total_survey_15_email ?? 0}
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}> </td>
                  <td className="text-center"> </td>
                </tr>
                <tr>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}> 16 </td>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0">Do you consider the waiting time:</p>
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    Brief <br/> {formData?.total_survey_16_brief ?? 0}
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    Reasonable <br/> {formData?.total_survey_16_reasonable ?? 0}
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    Excessive <br/> {formData?.total_survey_16_excessive ?? 0}
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}> </td>
                  <td className="text-center"> </td>
                </tr>
                <tr>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}> 17 </td>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0">Do you prefer appointments during the morning, afternoon, evening, or weekends?</p>
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    Morning <br/> {formData?.total_survey_17_morning ?? 0}
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    Afternoon <br/> {formData?.total_survey_17_afternoon ?? 0}
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    Evening <br/> {formData?.total_survey_17_evening ?? 0}
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    Weekend <br/> {formData?.total_survey_17_weekend ?? 0}
                  </td>
                  <td className="text-center"> </td>
                </tr>
                <tr>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}> 18 </td>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0">Which weeknight would you prefer extended hours?</p>
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    Monday <br/> {formData?.total_survey_18_monday ?? 0}
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    Tuesday <br/> {formData?.total_survey_18_tuesday ?? 0}
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    Wednesday <br/> {formData?.total_survey_18_wednesday ?? 0}
                  </td>
                  <td className="text-center" style={{ borderRight: '1px solid var(--border)' }}>
                    Thursday <br/> {formData?.total_survey_18_thursday ?? 0}
                  </td>
                  <td className="text-center">
                    Friday <br/> {formData?.total_survey_18_friday ?? 0}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="docpro_invoice_btns docpro_hide_print">
        <button
          className="docpro_invoice_btn docpro_color3 close_button"
          onClick={handleCloseWindow}
        >
          <span className="docpro_btn_icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
          </span>
          <span className="docpro_btn_text">Close</span>
        </button>

        <button
          className="docpro_invoice_btn docpro_color1"
          onClick={handlePrint}
        >
          <span className="docpro_btn_icon">
            <svg xmlns="http://www.w3.org/2000/svg" className="ionicon" viewBox="0 0 512 512" >
              <path d="M384 368h24a40.12 40.12 0 0040-40V168a40.12 40.12 0 00-40-40H104a40.12 40.12 0 00-40 40v160a40.12 40.12 0 0040 40h24" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth={32} />
              <rect x={128} y={240} width={256} height={208} rx="24.32" ry="24.32" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth={32} /> 
              <path d="M384 128v-24a40.12 40.12 0 00-40-40H168a40.12 40.12 0 00-40 40v24" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth={32} /> 
              <circle cx={392} cy={184} r={24} fill="currentColor" /> 
            </svg>
          </span>
          <span className="docpro_btn_text">Print</span>
        </button>
      </div>
    </div>
  );
}
